//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React, {Component} from 'react'
import i18 from '../../../i18'

class Row extends Component {

    constructor(props) {
        super(props)
        this.state = {
            rule: props.rule,
            company: props.company
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            rule: nextProps.rule,
        })
    }

    onEditRule = (event) => {
        this.props.onEditRule(this.state.rule)
    }

    onRemoveRule = (event) => {
        this.props.onRemoveRule(this.state.rule)
    }

    getRuleType = (type) => {
        return type === 'final' ? i18.COMMON._finalRule : i18.COMMON._temporarirlyRule
    }

    render() {
        return (
            <tr>
                <td>{this.state.rule.item_name ? this.state.rule.item_name : '-'}</td>
                <td>{this.state.rule.invoice_number ? this.state.rule.invoice_number : '-'}</td>
                <td>{this.state.rule.company_name ? this.state.rule.company_name : '-'}</td>
                <td>{this.state.rule.announcement ? this.state.rule.announcement : '-'}</td>
                <td>{this.state.rule.main_bookkeeping_number ? this.state.rule.main_bookkeeping_number : '-'}</td>
                {this.props.company && this.props.company.accountant_program_id === 2
                    ? <td>{this.state.rule.legal_title ? this.state.rule.legal_title : '-'}</td>
                    : null
                }
                <td>{this.getRuleType(this.state.rule.type)}</td>
                <td>{this.state.rule.updated_at}</td>
                <td>
                    <i onClick={(event) => this.onEditRule(event)} title={i18.CUSTOMER._editRule} className='fa fa-pencil-square-o' aria-hidden='true'></i> &nbsp;&nbsp;
                    <i onClick={(event) => this.onRemoveRule(event)} title={i18.CUSTOMER._deleteRule} className='fa fa-trash-o' aria-hidden='true'></i>
                </td>
            </tr>
        )
    }
}

export default Row


// WEBPACK FOOTER //
// ./src/components/bank/rules/row.js